import React from "react";
import Process from "../../Common/Process";

// export default function PostProcessingProcess({ startProcess, selectedFilesToProcess }) {
//     console.log("PostProcessingProcess - selectedFilesToProcess:", selectedFilesToProcess);
//     return (
//         <Process
//             startProcess={startProcess}
//             selectedFilesToProcess={selectedFilesToProcess}
//         />
//     );
// }

export default function PostProcessingProcess({ startProcess, selectedFilesToProcess }) {
    const normalizedFiles = (selectedFilesToProcess || []).map(f => ({
        ...f,
        status: "Inprogress",     // 👈 FORCE
        filename: f.filename || f.file_name || f.name
    }));

    console.log("Normalized:", normalizedFiles);

    return (
        <Process
            startProcess={startProcess}
            selectedFilesToProcess={normalizedFiles}
        />
    );
}

